import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { useAppDispatch, useAppSelector, useAppStore } from '@/lib/hooks';
import { setActiveCourseData } from '@/lib/slices/course-slice';

import { RefreshIcon } from '@/assets/icons/button';

import Request from '@/services/util/request-service';
import UtilityService from '@/services/util/utility-service';
import UserCourseStorageService from '@/services/storage/user-course-storage-service';
import { CourseData } from 'course-types';

export default function CourseCodeDisplay() {
  const store = useAppStore();
  const dispatch = useAppDispatch();

  const course: CourseData = useAppSelector(() => store.getState().course.activeCourseData);

  const [copyHover, setCopyHover] = useState<boolean>(false);
  const [refreshHover, setRefreshHover] = useState<boolean>(false);

  const [isOwner, setIsOwner] = useState<boolean>(false);

  useEffect(() => {
    const cookie = UserCourseStorageService.getCourseCookie();
    if (cookie) {
      setIsOwner(!!cookie.all.enterprise.find((c) => c.id == course.id));
    }
  }, [course]);

  const renderCourseCode = () => {
    return (
      <div className='flex items-center gap-1 group cursor-default'>
        <p>
          {course.course_code?.code ? 'Course code:' : `${isOwner ? '' : 'No course code found.'}`}
        </p>
        <a
          onClick={() => UtilityService.copyToClipboard(course.course_code?.code)}
          className='relative'
          onMouseEnter={() => setCopyHover(true)}
          onMouseLeave={() => setCopyHover(false)}
        >
          {copyHover && (
            <div
              className={`absolute flex w-fit text-nowrap bg-surface_gray_200 rounded-lg px-2 py-1 -top-8 -left-1/4 shadow-sm`}
            >
              Copy code
            </div>
          )}
          {course.course_code?.code}
        </a>
        {isOwner && (
          <a
            onClick={() => generateNewCode()}
            className='relative flex flex-row items-center gap-1'
            onMouseEnter={() => setRefreshHover(true)}
            onMouseLeave={() => setRefreshHover(false)}
          >
            {refreshHover && course.course_code?.code && (
              <div
                className={`absolute flex w-fit text-nowrap bg-surface_gray_200 rounded-lg px-2 py-1 -top-8 -left-1/4 shadow-sm`}
              >
                Refresh course code
              </div>
            )}
            {!course.course_code?.code && <p>Generate Course Code</p>}
            <RefreshIcon className='w-5 h-5 block cursor-pointer' />
          </a>
        )}
      </div>
    );
  };

  const generateNewCode = async () => {
    const response = await (
      await Request.post('admin/c/code/refresh', { courseId: course.id })
    )?.json();
    if (!response || response.error) {
      toast.error('Failed to generate new course code.');
    } else {
      const newCourseData: CourseData = {
        ...course,
        course_code: {
          code: response.code.id,
          isActive: response.code.isActive,
          expiration: response.code.expiration,
        },
      };
      dispatch(setActiveCourseData(newCourseData));
      setRefreshHover(false);
    }
  };

  return <div className='my-auto pt-1'>{renderCourseCode()}</div>;
}
